module.exports = __webpack_public_path__ + "static/media/section-5-mobile-min.d4082ade.png";